import React from 'react'
import { useSelector } from 'react-redux'
import { Tooltip } from '@mui/material'
import { isEmpty, pick } from 'lodash'
import { WrapIndication, CellWithButtonStyles } from './Style'
import { deviationRatingIndex, naLabel, ratingListLabel, ratingListTheme } from 'keys/rating'
import { statuses } from 'keys'
import { Done, NotificationsNone, Remove } from '@mui/icons-material'
import { CellWithTooltipStyles } from 'components/Table/Style'
import { visibilityStatuses, visibilityStatuses1 } from 'keys/visibilityStatuses'
import { secretStorage } from 'config'

const RateAndAccuracyCell = (props) => {
    const { row, column } = props
    const value = row.original
    const { meta } = column.columnDef
    const { ratingLabels } = meta
    const { rating, status, visibility_status, assessment_hidden } = value || {}
    const { scoreRatingMethods } = useSelector(state => state.rating)
    const ratingListLabels = ratingLabels || ratingListLabel
    const is_superuser = secretStorage.getItem("user")?.is_superuser

    const indicationIcon = {
        "noraml": {
            icon: Done,
            color: "success"
        },
        "warning": {
            color: "error",
            icon: NotificationsNone,
        },
        "nodata": {
            icon: Remove,
            color: "ligthGray"
        }
    }

    const { warning, noraml, nodata } = indicationIcon

    const ratingFields = pick(rating, [meta.id, meta.index])
    let ratingIndex = ratingFields[meta.index]
    let ratingId = ratingFields[meta.id]
    let currentScoreRatingMethod
    let indication

    if (status === statuses.brokenFile)
        currentScoreRatingMethod = {
            label: naLabel
        }

    else {
        if (isEmpty(scoreRatingMethods))
            currentScoreRatingMethod = {
                themeColor: ratingListTheme[ratingIndex - 1],
                label: ratingListLabels[ratingIndex - 1]
            }
        else {
            currentScoreRatingMethod = scoreRatingMethods?.[ratingId]
            ratingIndex = currentScoreRatingMethod?.index
        }

        indication = ratingIndex ? (ratingIndex <= deviationRatingIndex ? noraml : warning) : nodata
    }

    const showIcon = indication?.icon
    const color = currentScoreRatingMethod?.themeColor || 'ligthGray'
    const hiddenAssessment = assessment_hidden && !is_superuser

    return (
        <CellWithTooltipStyles blurred={hiddenAssessment}>
            <CellWithButtonStyles>
                <Tooltip title={currentScoreRatingMethod?.label} placement='top'>
                    <WrapIndication size={showIcon ? "sm" : "md"}>
                        {showIcon ?
                            <indication.icon
                                {...indication}
                                fontSize='small'
                                color={hiddenAssessment ? "black" : color}
                            /> :
                            currentScoreRatingMethod?.label}
                    </WrapIndication>
                </Tooltip>
            </CellWithButtonStyles>
        </CellWithTooltipStyles>
    )

}

export default RateAndAccuracyCell